module.exports = __webpack_public_path__ + "img/header-weddingRingsSignature@2x.eff0b43.webp";